export default {
    connectWallet: "connectWallet",
    signIn: "signIn",
    sendFromDogecoin: "sendFromDogecoin",
    sendFromEthereum: "sendFromEthereum",
    sendFromBridge: "sendFromBridge",
    xPub: "xPub",
    globalUnminted: "globalUnminted"
}